import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

export default function MomentStatusIndicator() {
    console.log("🧠 MomentStatusIndicator RUN", {
  activeMomentId: sessionStorage.getItem("active_moment_id"),
  leftFlag:
    sessionStorage.getItem(
      `moment_left_${sessionStorage.getItem("active_moment_id")}`
    ),
  suppressed: sessionStorage.getItem("moment_suppressed"),
});

  const [active, setActive] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      setActive(!!e.detail?.active);
    };

    window.addEventListener("moment-active", handler);
    return () => window.removeEventListener("moment-active", handler);
  }, []);

  if (!active) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: 36,
        height: 4,
        borderRadius: 999,
        bgcolor: "#16A34A",
        zIndex: 2000,
      }}
    />
  );
}
